module.exports = __webpack_public_path__ + "static/media/Fitness Instructor.b2d8f9bc.jpg";